<template>
  <div class="flex flex-nowrap md:flex-wrap lg:flex-nowrap">
    <div class="flex xxs:flex-col mlg:flex-row flex-1 pr-2 xxl:pr-4" @click="router.push(`/news/${article.uid}`)">
        <Image v-if="thumbnail && thumbnail.length > 0" :src="thumbnail" class="w-20" type="thumbnail" roundness="rounded" />
      <div class="flex flex-col flex-1" :class="thumbnail && thumbnail.length > 0 && 'ml-4'">
        <p
            class="text-body-6 font-medium text-default-1 hover:text-primary-1 mb-0.5 overflow-hidden overflow-ellipsis max-h-[60px] multi-line-ellipsis clamp-1-line -mt-0.5">
          {{ article.title }}
        </p>
        <p class="text-body-7 font-normal text-default-2">
          {{moment(article.created_at).format("MMM DD, YY")}}
        </p>
      </div>
    </div>
    <Like
        class="self-center ml-auto"
        :likes-count="article.total_likes"
        :is-liked="article.is_liked"
        :articleUid="article.uid"
        @toggle-like="$emit('toggleLike')"
        :has-background-style="false"
    />
  </div>
</template>
<script setup>
import { computed } from "vue";
import moment from "moment";
import Like from "@/components/custom/news/Like.vue";
import router from "@/router";
import Image from "@/components/custom/Image.vue";

const emit = defineEmits(["toggleLike"]);

const props = defineProps({
    article: {
        type: Object,
    },
});

const thumbnail = computed(() => {
    if (!props.article || (props.article.thumbnail && props.article.thumbnail.length === 0)) {
        return "";
    }

    return props.article.thumbnail;
});
</script>
